declare var AFRAME;

AFRAME.registerComponent('showroom', {
    init: function () {
        const showroom = new Showroom(showroomConfiguration);
        const controls = new DblclickControls(document.querySelector('a-scene'), document.querySelector('#floor-plane'), document.querySelectorAll('.wall'));
        controls.activate();
        showroom.createRoof([
            [-2, -2],
            [-2, 2],
            [2, 2],
            [2, -2]
        ], 5);
        showroom.ready().then(() => {
            console.log("The showroom is ready!");
            const button = document.getElementById('enter-button');
            button.removeAttribute('disabled');
            button.innerText = "ENTER";
            document.getElementById('loading-stuck-text').remove();
            document.querySelector('[countdown]').setAttribute('countdown', {
                deadline: new Date(new Date().getTime() + 1000 * 45)
            });
        })
    }
});